// extracted by css-extract-rspack-plugin
export default {"monospace":"ErrorDetails-module__monospace___oUD80"};